import { Pipe, PipeTransform } from '@angular/core';
import { MileageCarEnum } from '@app/salesfunnel/enums/mileage-car.enum';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'mileageCar',
})
export class MileageCarPipe implements PipeTransform {
    transform(input: any): string {
        if (
            [
                +MileageCarEnum.LessThen15000,
                +MileageCarEnum.Between15000And25000,
                +MileageCarEnum.MoreThen25000,
            ].includes(input) ||
            [
                MileageCarEnum.LessThen15000.toString(),
                MileageCarEnum.Between15000And25000.toString(),
                MileageCarEnum.MoreThen25000.toString(),
            ].includes(input)) {
            if (input === MileageCarEnum.LessThen15000.toString() || input === +MileageCarEnum.LessThen15000) {
                return 'Minder dan 15.000 km';
            }
            if (input === MileageCarEnum.Between15000And25000.toString() ||
                input === +MileageCarEnum.Between15000And25000) {
                return 'Tussen de 15.000 en 25.000 km';
            }
            if (input === MileageCarEnum.MoreThen25000.toString() || input === +MileageCarEnum.MoreThen25000) {
                return 'Meer dan 25.000 km';
            }
            return;
        }
    }
}
